import React from "react";
import { Typography } from "@mui/material";

interface LogoutSuccessAlertProps {
  [key: string]: any;
}

function LogoutSuccessAlert(props: LogoutSuccessAlertProps) {
  return (
    <div className="flex flex-col p-4 items-start self-stretch gap-1 bg-white rounded-lg border border-affirmation-light ;">
      <div className="flex items-start pl-7 self-stretch">
        <img
          src="/assets/icons/Terminal.svg"
          alt="Terminal Icon"
          className="w-4 h-4 "
        />
        <Typography className="flex-grow flex-shrink-0 basis-0 text-affirmation-light font-sans text-base font-medium leading-base ">
          Logout successFull
        </Typography>
      </div>
      <div className="flex pl-7 justify-center items-center self-stretch">
        <Typography className="flex-grow flex-shrink-0 basis-0 text-affirmation-dark font-sans text-base font-medium leading-base">
          We hope your session was productive!
        </Typography>
      </div>
    </div>
  );
}

export default LogoutSuccessAlert;
